"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ldflex = require("ldflex");

function _asyncIterator(iterable) {
  var method;

  if (typeof Symbol !== "undefined") {
    if (Symbol.asyncIterator) {
      method = iterable[Symbol.asyncIterator];
      if (method != null) return method.call(iterable);
    }

    if (Symbol.iterator) {
      method = iterable[Symbol.iterator];
      if (method != null) return method.call(iterable);
    }
  }

  throw new TypeError("Object is not async iterable");
}
/**
 * node-solid-server deviates from the SPARQL UPDATE spec:
 * whereas the spec asks for DELETE on non-existing triples to silently succeed,
 * node-solid-server will only DELETE if exactly one triple matches.
 *
 * This delete handler works around that limitation
 * by first requesting all existing values for a path,
 * and then only issuing DELETE statements for those that exist.
 */


var SolidDeleteFunctionHandler =
/*#__PURE__*/
function (_ldflex$DeleteFunctio) {
  _inherits(SolidDeleteFunctionHandler, _ldflex$DeleteFunctio);

  function SolidDeleteFunctionHandler() {
    _classCallCheck(this, SolidDeleteFunctionHandler);

    return _possibleConstructorReturn(this, _getPrototypeOf(SolidDeleteFunctionHandler).apply(this, arguments));
  }

  _createClass(SolidDeleteFunctionHandler, [{
    key: "extractObjects",
    value: function () {
      var _extractObjects = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pathData, path, args) {
        var objects, existing, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, term;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _get(_getPrototypeOf(SolidDeleteFunctionHandler.prototype), "extractObjects", this).call(this, pathData, path, args);

              case 2:
                objects = _context.sent;
                // Obtain all values that currently exist
                existing = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context.prev = 6;
                _iterator = _asyncIterator(path);

              case 8:
                _context.next = 10;
                return _iterator.next();

              case 10:
                _step = _context.sent;
                _iteratorNormalCompletion = _step.done;
                _context.next = 14;
                return _step.value;

              case 14:
                _value = _context.sent;

                if (_iteratorNormalCompletion) {
                  _context.next = 21;
                  break;
                }

                term = _value;
                if (term.termType !== 'BlankNode') existing.push(term);

              case 18:
                _iteratorNormalCompletion = true;
                _context.next = 8;
                break;

              case 21:
                _context.next = 27;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context["catch"](6);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 27:
                _context.prev = 27;
                _context.prev = 28;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context.next = 32;
                  break;
                }

                _context.next = 32;
                return _iterator.return();

              case 32:
                _context.prev = 32;

                if (!_didIteratorError) {
                  _context.next = 35;
                  break;
                }

                throw _iteratorError;

              case 35:
                return _context.finish(32);

              case 36:
                return _context.finish(27);

              case 37:
                return _context.abrupt("return", !objects ? existing : existing.filter(function (e) {
                  return objects.some(function (o) {
                    return o.equals(e);
                  });
                }));

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 23, 27, 37], [28,, 32, 36]]);
      }));

      function extractObjects(_x, _x2, _x3) {
        return _extractObjects.apply(this, arguments);
      }

      return extractObjects;
    }()
  }]);

  return SolidDeleteFunctionHandler;
}(_ldflex.DeleteFunctionHandler);

exports.default = SolidDeleteFunctionHandler;